import { useGetCareerDescription } from '../data-access-career-description'
import Goals from '../ui-goals'

type CareerGoalsProps = {
  slug?: string
}

const CareerGoals = ({ slug }: CareerGoalsProps) => {
  const { careerDescription } = useGetCareerDescription(slug)

  return <Goals {...careerDescription.goalsData} />
}

export default CareerGoals
